import React, {useEffect} from 'react';

import auth from '../../common/api/Firebase';
import axios from "axios";
import ProductListing from "../ProductListing/ProductListing";
// import Login from "./api/firebaseAPI";
// import Login from "../../common/api/firebaseAPI";
import { addProducts } from '../../features/productSlice/productSlice';
import { useDispatch } from 'react-redux';




const Home = () => {
    const dispatch = useDispatch();
    
useEffect(() => {
    //Start Login
  

    // Sign in Anonymously to the Firebase
    const signin = () => {
        auth.signInAnonymously().then(() => {
    // declare the data fetching function
    const fetchData = async  () => {

     

      const data = await 
      axios.get(`https://med-fashion-default-rtdb.firebaseio.com/Products.json`)
      .then(function (response) {
        // handle success
         dispatch(addProducts(response.data));
        // console.log(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
    
    };

    // console.log("signed In");
 fetchData();
          })
        .catch(alert);
    }
   signin();
    // End Login 

     },[]);
    return (
        <div>
        <ProductListing />
        </div>
    );
};

export default Home;